import { ActionType } from '../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../core/api/rsaa';
import { Endpoints } from '../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../core/api/module';
import * as R from 'ramda';
import { Project } from './models';


const KEY_ACTION = ActionType.LoadProjectsRequest;
const ACTIONS    = [
  ActionType.LoadProjectsRequest,
  ActionType.LoadProjectsResponse,
  ActionType.LoadProjectsError,
];


type Payload = Project[];
type Meta = { personId: number; };


/**
 * Dispatch this action to load the list of projects associated with a specific person
 */
export const loadProjectsAction = (personId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.Projects,
  headers:  { 'content-type': 'application/json' },
  body: (state) => (JSON.stringify({ personId: personId, languageId: state.locale.lang.languageId})),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { personId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assoc('projects', payload, successState);
};


export const loadProjectsReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
